export var CardColor;
(function (CardColor) {
    CardColor["Red"] = "RED";
    CardColor["Green"] = "GREEN";
    CardColor["Black"] = "BLACK";
    CardColor["Purple"] = "PURPLE";
    CardColor["Yellow"] = "YELLOW";
    CardColor["Pink"] = "PINK";
})(CardColor || (CardColor = {}));
export const PROTOCOL_VERSION = 1;
export var CardType;
(function (CardType) {
    CardType["Attack"] = "ATTACK";
    CardType["Defense"] = "DEFENSE";
    CardType["Heal"] = "HEAL";
    CardType["PsySearch"] = "PSY_SEARCH";
    CardType["Steal"] = "STEAL";
    CardType["Shock"] = "SHOCK";
    CardType["Energize"] = "ENERGIZE";
    CardType["Hibernation"] = "HIBERNATION";
    CardType["Pushback"] = "PUSHBACK";
    CardType["StealTower"] = "STEAL_TOWER";
    CardType["Dispel"] = "DISPEL";
    CardType["DoubleCross"] = "DOUBLE_CROSS";
    CardType["BodyUpgrade"] = "BODY_UPGRADE";
    CardType["FortunesFavor"] = "FORTUNES_FAVOR";
    CardType["ArcaneBoots"] = "ARCANE_BOOTS";
    CardType["PsyBlock"] = "PSY_BLOCK";
    CardType["Disease"] = "DISEASE";
    CardType["BrokenSecret"] = "BROKEN_SECRET";
    CardType["Counterblast"] = "COUNTERBLAST";
    CardType["PlantedBomb"] = "PLANTED_BOMB";
    CardType["Chromabow"] = "CHROMABOW";
    CardType["CursedIron"] = "CURSED_IRON";
    CardType["DiscerningEye"] = "DISCERNING_EYE";
    CardType["Ale"] = "ALE";
    CardType["EnergySword"] = "ENERGY_SWORD";
    CardType["EyesOfMadness"] = "EYES_OF_MADNESS";
    CardType["FlyingScythe"] = "FLYING_SCYTHE";
    CardType["Frost"] = "FROST";
    CardType["InfernoGauntlet"] = "INFERNO_GAUNTLET";
    CardType["Invincible"] = "INVINCIBLE";
    CardType["Larcendagger"] = "LARCENDAGGER";
    CardType["LifeCharger"] = "LIFE_CHARGER";
    CardType["LifeDrain"] = "LIFE_DRAIN";
    CardType["MadnessControl"] = "MADNESS_CONTROL";
    CardType["NaturalGrip"] = "NATURAL_GRIP";
    CardType["Protector"] = "PROTECTOR";
    CardType["TwilightShift"] = "TWILIGHT_SHIFT";
    CardType["SealOfSilence"] = "SEAL_OF_SILENCE";
    CardType["ThunderSprint"] = "THUNDER_SPRINT";
    CardType["Trembling"] = "TREMBLING";
    CardType["VoodooDoll"] = "VOODOO_DOLL";
    CardType["Purification"] = "PURIFICATION";
    CardType["CardCyclone"] = "CARD_CYCLONE";
    CardType["MageTower"] = "MAGE_TOWER";
})(CardType || (CardType = {}));
export var GamePhase;
(function (GamePhase) {
    GamePhase["TowerChoice"] = "TOWER_CHOICE";
    GamePhase["TowerPurchase"] = "TOWER_PURCHASE";
    GamePhase["StashChoice"] = "STASH_CHOICE";
    GamePhase["Preparation"] = "PREPARATION";
    GamePhase["Combat"] = "COMBAT";
    GamePhase["RoundEnd"] = "ROUND_END";
    GamePhase["GameOver"] = "GAME_OVER";
    GamePhase["AWAITING_PURIFICATION_TARGET"] = "AWAITING_PURIFICATION_TARGET";
    GamePhase["LockedCardOverflow"] = "LOCKED_CARD_OVERFLOW";
    GamePhase["AWAITING_CHROMABOW_CHOICE"] = "AWAITING_CHROMABOW_CHOICE";
    GamePhase["AWAITING_HIBERNATION_CHOICE"] = "AWAITING_HIBERNATION_CHOICE";
    GamePhase["AWAITING_BURGLARY_CHOICE"] = "AWAITING_BURGLARY_CHOICE";
    GamePhase["LorianClassChoice"] = "LORIAN_CLASS_CHOICE";
    GamePhase["BROKEN_SECRET_REVEAL"] = "BROKEN_SECRET_REVEAL";
    GamePhase["LifeChargerPending"] = "LIFE_CHARGER_PENDING";
})(GamePhase || (GamePhase = {}));
